import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M16 13L19 16L16 19" />
		<Path d="M4 8H20M4 16H13.5" />
	</SVG>
);
